import { createRecord, listRecords, deleteRecord, uploadMedia, mediaUrl, MEDIA_BUCKET } from './supabase';

export async function createContent({ title, content, category = null, type, file }) {
    // Keep an uploaded file if the record write has an uncertain outcome. Removing
    // it here could break a successful write whose response was interrupted.
    const uploaded = file ? await uploadMedia(MEDIA_BUCKET, file) : null;
    return createRecord('content', { title, content, category, type, imageId: uploaded?.id || null });
}

export const articleUtils = {
    createArticle: ({ title, content, imageFile, type = 'article' }) =>
        createContent({ title, content, file: imageFile, type }),
    async getArticles() {
        return (await listRecords('content', { type: 'article' })).map(row => ({
            ...row, imageUrl: mediaUrl(MEDIA_BUCKET, row.imageId),
        }));
    },
    // Files can be shared by legacy records. Retain originals when removing a post.
    deleteArticle: id => deleteRecord('content', id),
};
